const Routes = [
  {
    path: '/product-follow-up',
    name: 'ProductFollowUp',
    component: () => import('@/app/product_follow_up/TheProductFollowUp'),
    redirect: '/product-follow-up/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/product_follow_up/views/Index')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/product_follow_up/Routes.js